// app/src/simulations/receiptStore.ts
export type ContributeReceipt = {
  kind: "contribute_v2";
  signature: string;
  createdAt: string; // ISO
  endpoint: string;
  programId: string;
  pool_v2: string;
  member_v2: string;
  vault_v2: string;
  lamports: string;
  confirmationStatus?: string | null;
  feeLamports?: number | null;
  error?: string | null;
};

const KEY = "weare_susu_receipts_v1";

function safeParse<T>(s: string | null): T | null {
  if (!s) return null;
  try {
    return JSON.parse(s) as T;
  } catch {
    return null;
  }
}

export function loadReceipts(): ContributeReceipt[] {
  try {
    const raw = window.localStorage.getItem(KEY);
    const v = safeParse<ContributeReceipt[]>(raw);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export function saveReceipt(r: ContributeReceipt) {
  const list = loadReceipts();
  list.unshift(r);
  // cap to last 50
  const capped = list.slice(0, 50);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(capped));
  } catch {
    // ignore storage errors
  }
}

export function clearReceipts() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
